import { render, staticRenderFns } from "./OutboundManagement.vue?vue&type=template&id=27a07777&scoped=true"
import script from "./OutboundManagement.vue?vue&type=script&lang=js"
export * from "./OutboundManagement.vue?vue&type=script&lang=js"
import style0 from "./OutboundManagement.vue?vue&type=style&index=0&id=27a07777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a07777",
  null
  
)

export default component.exports